module.exports = [{"type":"title","text":"2024-07-30"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"永續U本位：所有行情接口和websocket DataType支持USDC幣對。"},{"type":"html","text":"新增: /openApi/swap/v3/user/balance 同時返回 USDT 和 USDC"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2024-07-30.json
// module id = l7kI
// module chunks = 3